import type {LocationQuery} from 'vue-router';

export type TQueryObjectValue = undefined | null | boolean | string | number;

export interface IQueryObject {
  [key: string]: TQueryObjectValue | TQueryObjectValue[];
}

const delimiter = '&';
const getQueryPath = (key: string, value: TQueryObjectValue) => {
  const currentKey = encodeURIComponent(key);
  const currentValue = encodeURIComponent(value?.toString() ?? '');
  return currentKey + '=' + currentValue;
};

// eslint-disable-next-line valid-jsdoc
/**
 * Метод сериализации объекта в query string
 * @typedef {type} T - Тип объекта для сериализации
 * @param {T} obj - Объект для сериализации
 * @return {Array<keyof T>} - query string
 **/
export function serializeFromObjectToQueryString<
  T extends IQueryObject | LocationQuery,
>(obj: T) {
  return Object.entries(obj)
    .filter(([, value]) => value != null && value !== '')
    .map(([key, value]) => {
      if (Array.isArray(value))
        return value
          .map((item) => getQueryPath(key, item as string))
          .join(delimiter);
      else return getQueryPath(key, value as string);
    })
    .filter((value) => value !== '')
    .join(delimiter);
}
